import { useRef, useCallback, forwardRef } from "react";
import PropTypes from "prop-types";
import styles from "./Track.css";

const Track = forwardRef(({ children, onTrackMouseDown, percentages }, ref) => {
  const internalRef = useRef(null);
  const nodeRef = ref || internalRef;

  const getActiveTrackStyle = useCallback(() => {
    const width = `${(percentages.max - percentages.min) * 100}%`;
    const left = `${percentages.min * 100}%`;

    return { left, width };
  }, [percentages]);

  const handleMouseDown = useCallback(
    event => {
      const clientX = event.touches ? event.touches[0].clientX : event.clientX;
      const trackClientRect = nodeRef.current.getBoundingClientRect();
      const position = {
        x: clientX - trackClientRect.left,
        y: 0
      };
      onTrackMouseDown(position, event);
    },
    [nodeRef, onTrackMouseDown]
  );

  const handleTouchStart = useCallback(
    event => {
      event.preventDefault();
      handleMouseDown(event);
    },
    [handleMouseDown]
  );

  const activeTrackStyle = getActiveTrackStyle();

  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    <div
      aria-label="Range track"
      className={styles.track}
      onMouseDown={handleMouseDown}
      onTouchStart={handleTouchStart}
      ref={nodeRef}
    >
      <div className={styles.trackBackground} />
      <div
        style={activeTrackStyle}
        className={`${styles.track} ${styles.activeTrack}`}
      />
      {children}
    </div>
  );
});

Track.displayName = "Track";

Track.propTypes = {
  children: PropTypes.node.isRequired,
  onTrackMouseDown: PropTypes.func.isRequired,
  percentages: PropTypes.objectOf(PropTypes.number).isRequired
};

export default Track;
